'use client'

import { MapPin } from "lucide-react"
import { useTranslations } from 'next-intl'

/**
 * Interface representing the opening hours for a specific day.
 */
interface OpeningHour {
  /**
   * The day of the week.
   */
  day: string;

  /**
   * The opening hours for the day. If not provided, the day is not open.
   */
  hours?: string;
}

/**
 * Props for the StoreOpeningHours component.
 */
interface StoreOpeningHoursProps {
  /**
   * An array of opening hours for the store.
   */
  hours: OpeningHour[];

  /**
   * The location of the store.
   */
  location?: string;
}

export function StoreOpeningHours({ location, hours }: StoreOpeningHoursProps) {
  const t = useTranslations('Store.OpeningHours')

  return (
    <div>
      <h3 className="text-lg font-medium">{t('title')}</h3>
      {location && <p className="text-sm text-muted-foreground flex items-center gap-2 mt-2 mb-4">
        <MapPin className="h-5 w-5" />
        {location}
      </p>}
      <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm text-muted-foreground mt-2">
        {hours.map((item) => (
          <div key={item.day} className="flex justify-between">
            <span>{item.day}</span>
            <span>{item.hours || t('closed')}</span>
          </div>
        ))}
      </div>
    </div>
  )
} 